export default "__VITE_ASSET__BcV$icP___"